import React, { useCallback, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { useAuth } from '../../context/AuthContext';
import { bottomNavItems, isMobileMenuRouteActive } from '../../constants/navigation';
import MobileNavMenu from './MobileNavMenu';

const navItemClassName = (isActive) =>
  `flex flex-col items-center justify-center w-full h-full transition-colors ${
    isActive ? 'text-brand-cyan' : 'text-[var(--text-secondary)] hover:text-[var(--text-main)]'
  }`;

export default function BottomNav() {
  const { pathname } = useLocation();
  const { can } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = useCallback(() => setMenuOpen(false), []);
  const menuRouteActive = isMobileMenuRouteActive(pathname, can);

  return (
    <>
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-[var(--bg-surface)] backdrop-blur-md border-t border-[var(--border-subtle)] pb-safe z-50 transition-colors duration-300">
        <div className="flex justify-around items-center h-16">
          {bottomNavItems.map((item) =>
            item.isMenu ? (
              <button
                key={item.label}
                type="button"
                onClick={() => setMenuOpen(true)}
                aria-expanded={menuOpen}
                aria-haspopup="dialog"
                className={navItemClassName(menuRouteActive)}
              >
                <SafeIcon name={item.icon} className="w-5 h-5 mb-0.5" />
                <span className="text-[9px] font-bold uppercase tracking-tight">{item.label}</span>
              </button>
            ) : item.disabled ? (
              <div
                key={item.label}
                className="flex flex-col items-center justify-center w-full h-full text-[var(--text-secondary)] opacity-40"
              >
                <SafeIcon name={item.icon} className="w-5 h-5 mb-0.5" />
                <span className="text-[9px] font-bold uppercase tracking-tight">{item.label}</span>
              </div>
            ) : (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/app'}
                className={({ isActive }) => navItemClassName(isActive)}
              >
                <SafeIcon name={item.icon} className="w-5 h-5 mb-0.5" />
                <span className="text-[9px] font-bold uppercase tracking-tight">{item.label}</span>
              </NavLink>
            )
          )}
        </div>
      </nav>

      <MobileNavMenu isOpen={menuOpen} onClose={closeMenu} />
    </>
  );
}
